export default "__VITE_ASSET__peg7mNBR__"